export const environment = {
  production: false,
  ApiUrl: "https://prontuario-atos.com.br"
};
